import React from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { getSidePanelState } from '../../functions';
import SidePanelFloatingWindow from './SidePanelFloatingWindow';
/**
 * Portal layer that mounts all floating side panel windows.
 *
 * @returns {React.ReactPortal | null}
 */
export default function SidePanelFloatingLayer() {
    const { floatingTabs } = useSelector(getSidePanelState);
    if (!floatingTabs.length || typeof document === 'undefined') {
        return null;
    }
    return ReactDOM.createPortal(React.createElement(React.Fragment, null, floatingTabs.map(tabId => (React.createElement(SidePanelFloatingWindow, { key: tabId, tabId: tabId })))), document.body);
}
